import React from "react";
import { Result } from "antd";
import { Link } from "react-router-dom";


const SomethingWentWrong = () => {

    return (
        <Result
            status="500"
            title="500"
            subTitle="⚠️Something went wrong. Please try again later."
            extra={
                <Link to={"/"}  className="back-home-button" onClick={()=>console.log('clicked')}>
                    Back Home
                </Link>
            }
        />
    );
};
export default SomethingWentWrong;
